import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Document,
  View,
  Page,
  Text,
  PDFViewer,
  Image,
  StyleSheet,
  PDFDownloadLink,
} from "@react-pdf/renderer";
import { getAllDocumentos } from "../../../redux/documentos/documentosAction";
import Select from "react-select";
import "../../../index.css";
import RotulosPdf from "./rotuloPdf";
import { rotuloSelectStyles } from "./rotulosStyle";

export default function RotulosPedidos() {
  const dispatch = useDispatch();
  const documentos = useSelector((state) => state.documentos.allDocumentos);
  const [selectDocumento, setSelectDocumento] = useState({});
  const [bultos, setBultos] = useState();
  const [rotulos, setRotulos] = useState();
  const [verPDF, setVerPDF] = useState(false);

  useEffect(() => {
    dispatch(getAllDocumentos());
  }, [dispatch]);
  console.log(documentos);

  useEffect(() => {
    handleRotulos();
  }, [bultos]);

  const options =
    documentos[0] &&
    documentos[0].map((doc) => ({
      label: `Documento N° ${doc.numDocumento} - ${
        doc.cliente && doc.cliente.nombre
      }`,
      value: doc._id,
    }));

  const CustomDropdownIndicator = () => null;

  const handleDocumento = (option) => {
    console.log(option);
    const findDocumento = documentos[0].find((x) => x._id === option.value);
    console.log(findDocumento);

    setSelectDocumento({
      numDocumento: findDocumento.numDocumento,
      cliente: findDocumento.cliente.nombre,
      ciudad: findDocumento.cliente.ciudad,
      direccion: findDocumento.cliente.direccion,
      zona: findDocumento.cliente.zona,
    });
  };

  const handleCantidad = (e) => {
    console.log(e.target.value);
    const { value } = e.target;
    setBultos(e.target.value);
  };

  const handleRotulos = () => {
    const arrayRepetido = Array.from({ length: bultos }, () => ({
      ...selectDocumento,
    }));
    setRotulos(arrayRepetido);
  };

  console.log(rotulos);

  return (
    <>
      <div className="bg-custom container-custom">
        <div className="text-orange-500">
          <p className="mb-2 text-[20pt] font-semibold">Rotulos</p>
          <div className="mt-8">
            <p className="text-[14pt] font-semibold mb-4">Elegir Pedido</p>
            <Select
              styles={rotuloSelectStyles()}
              options={options}
              onChange={handleDocumento}
            />
          </div>
          <div className="mt-8">
            <p className="text-[14pt] font-semibold mb-4 mr-4">
              Ingresar Cantidad de bultos
            </p>
            <input
              className="w-[100px] rounded border text-black font-semibold text-right bg-[#d3d3d3]"
              type="number"
              onChange={handleCantidad}
              value={bultos}
            />
          </div>
          <div>
            <button
              className="mt-10 rounded text-black font-bold w-[100px] h-[50px] bg-sky-300 hover:bg-sky-500"
              onClick={() => setVerPDF(true)}
            >
              Imprimir
            </button>
          </div>
        </div>

        {/*PDF*/}
        {verPDF && rotulos.length > 0 ? (
          <div
            className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-0-sm
                              flex flex-col justify-center items-center"
          >
            <div className="bg-red-500 w-1/12 text-center rounded hover:bg-red-600">
              <button
                className="text-black font-bold hover:text-white"
                onClick={() => setVerPDF(false)}
              >
                Cerrar
              </button>
            </div>
            <div>
              <PDFViewer style={{ width: "118vh", height: "90vh" }}>
                <Document>
                  {rotulos.map(
                    (e, index) =>
                      index % 2 === 0 && (
                        <Page size="A4" key={index}>
                          <View style={{ height: "50%" }}>
                            <RotulosPdf
                              numDocumento={e.numDocumento}
                              cliente={e.cliente}
                              ciudad={e.ciudad}
                              direccion={e.direccion}
                              zona={e.zona}
                              rotuloNumero={index + 1}
                              rotulosTotal={bultos}
                            />
                          </View>
                          {rotulos[index + 1] && (
                            <View style={{ height: "50%" }}>
                              <RotulosPdf
                                numDocumento={rotulos[index + 1].numDocumento}
                                cliente={rotulos[index + 1].cliente}
                                ciudad={rotulos[index + 1].ciudad}
                                direccion={rotulos[index + 1].direccion}
                                zona={rotulos[index + 1].zona}
                                rotuloNumero={index + 2}
                                rotulosTotal={bultos}
                              />
                            </View>
                          )}
                        </Page>
                      )
                  )}
                </Document>
              </PDFViewer>
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
}
